export function MentionsLegales() {
  return (
    <div data-testid="page-mentions" className="pt-32 pb-20 px-6 md:px-12 lg:px-24 min-h-screen max-w-4xl mx-auto">
      <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6">Informations légales</p>
      <h1 className="font-serif text-5xl sm:text-6xl text-[#1A1A1A] leading-tight font-light mb-12">
        Mentions <em className="text-[#2C402E]">Légales</em>
      </h1>
      <div className="space-y-10 text-[#4A4A4A] font-body leading-relaxed">
        <Section title="Éditeur du site">
          <p><strong className="text-[#1A1A1A]">Challenges Littéraires Éditions (CLED)</strong></p>
          <p>Siège social : 33 avenue Philippe Auguste, 75011 Paris, France</p>
          <p>SIRET : 791 029 168 00030</p>
          <p>RCS Paris</p>
          <p>Directeur de la publication : Kellyoh</p>
          <p>Téléphone : +33 7 80 95 12 17</p>
          <p>Email : challengeslitteraires.editions@gmail.com</p>
        </Section>
        <Section title="Hébergement">
          <p>Le site est hébergé par Emergent Cloud Services.</p>
        </Section>
        <Section title="Propriété intellectuelle">
          <p>L'ensemble du contenu du site (textes, images, logos, illustrations, photographies, couvertures de livres) est la propriété exclusive de Challenges Littéraires Éditions ou de ses partenaires (auteurs, ayants droit). Toute reproduction, distribution, modification ou utilisation, totale ou partielle, sans autorisation écrite préalable est strictement interdite et constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.</p>
        </Section>
        <Section title="Données personnelles">
          <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée, vous disposez d'un droit d'accès, de rectification, de portabilité, de limitation, d'opposition et de suppression de vos données personnelles.</p>
          <p>Pour exercer ces droits, contactez-nous à : challengeslitteraires.editions@gmail.com</p>
          <p>Les données collectées via les formulaires (contact, soumission de manuscrit) sont conservées uniquement le temps nécessaire au traitement de votre demande et ne sont jamais cédées à des tiers.</p>
        </Section>
        <Section title="Cookies">
          <p>Le site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement (session, navigation). Aucun cookie publicitaire ni de traçage tiers n'est déposé.</p>
        </Section>
        <Section title="Crédits">
          <p>Conception et développement : Emergent.</p>
        </Section>
      </div>
    </div>
  );
}

export function CGV() {
  return (
    <div data-testid="page-cgv" className="pt-32 pb-20 px-6 md:px-12 lg:px-24 min-h-screen max-w-4xl mx-auto">
      <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6">Conditions générales</p>
      <h1 className="font-serif text-5xl sm:text-6xl text-[#1A1A1A] leading-tight font-light mb-12">
        Conditions Générales <em className="text-[#2C402E]">de Vente</em>
      </h1>
      <div className="space-y-10 text-[#4A4A4A] font-body leading-relaxed">
        <Section title="Article 1 — Objet">
          <p>Les présentes Conditions Générales de Vente (CGV) régissent les relations entre Challenges Littéraires Éditions (CLED), sise 33 avenue Philippe Auguste, 75011 Paris, SIRET 791 029 168 00030, et toute personne souhaitant acquérir un ouvrage publié par notre maison.</p>
        </Section>
        <Section title="Article 2 — Commandes">
          <p>Nos ouvrages sont disponibles sur Amazon, à la Fnac, chez Eyrolles, dans nos librairies partenaires et sur les principales plateformes de distribution. Les commandes sont régies par les conditions de chaque plateforme respective.</p>
        </Section>
        <Section title="Article 3 — Prix">
          <p>Les prix indiqués sur le site sont en euros, toutes taxes comprises (TVA à 5,5 % pour les livres physiques et 5,5 % pour les ebooks). Le prix de vente est conforme au prix unique du livre tel qu'institué par la loi Lang du 10 août 1981.</p>
        </Section>
        <Section title="Article 4 — Livraison">
          <p>Les délais et frais de livraison sont définis par la plateforme de vente choisie au moment de la commande. CLED ne saurait être tenu responsable des retards ou avaries indépendants de sa volonté.</p>
        </Section>
        <Section title="Article 5 — Droit de rétractation">
          <p>Conformément aux articles L.221-18 et suivants du Code de la consommation, le consommateur dispose d'un délai de 14 jours pour exercer son droit de rétractation, sans avoir à justifier de motif. Ce délai court à compter de la réception du bien.</p>
        </Section>
        <Section title="Article 6 — Soumission de manuscrits">
          <p>Les manuscrits soumis via notre formulaire restent l'entière propriété de leurs auteurs. CLED s'engage à les examiner dans la plus stricte confidentialité. Aucune rémunération ni indemnité n'est due pour l'envoi d'un manuscrit. Une réponse motivée est apportée sous 6 à 8 semaines.</p>
          <p>En cas de signature d'un contrat d'édition, les conditions financières et patrimoniales sont précisées au cas par cas dans le contrat.</p>
        </Section>
        <Section title="Article 7 — Service client">
          <p>Pour toute question, réclamation ou information complémentaire, vous pouvez nous contacter à challengeslitteraires.editions@gmail.com ou au +33 7 80 95 12 17.</p>
        </Section>
        <Section title="Article 8 — Litiges et droit applicable">
          <p>Les présentes CGV sont régies par le droit français. En cas de litige, une solution amiable sera recherchée en priorité. À défaut, tout litige relèvera de la compétence exclusive des tribunaux de Paris.</p>
        </Section>
      </div>
    </div>
  );
}

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">{title}</h2>
    <div className="space-y-2 text-base">{children}</div>
  </section>
);
